<template>
    <button class="button button--back" @click="navigateBack" aria-label="back">
        <div class="icon"></div>
        <span>Back</span>
    </button>
</template>
<script>
export default {
    methods: {
        navigateBack() {
            if (app.api.PageManager.getIsContentComponentOpen()) app.api.PageManager.closeAllContentComponents();
            else app.api.PageManager.navigateToParentScene();
        }
    },

}
</script>
<style lang="scss" scoped>
.button {
    position: absolute;
    left: var(--page-margin);
    bottom: var(--page-margin-bottom);
}
</style>